import { ActionTypes } from '../actions/feature-flag.actions';
import { clone } from 'lodash';
export const initialState = {
    global: {
        projectKey: '',
        flags: {}
    },
    app: {
        projectKey: '',
        flags: {}
    },
    initialized: false
};
export function featureFlagsReducer(state = initialState, action) {
    switch (action.type) {
        case ActionTypes.LOAD_FLAGS:
            return state;
        case ActionTypes.LOAD_FLAGS_FROM_CONFIG:
            return state;
        case ActionTypes.SET_FLAGS: {
            const { project, flags } = action.payload;
            const newFlagSet = { projectKey: project, flags: flags };
            return {
                ...state,
                ...{ app: newFlagSet }
            };
        }
        case ActionTypes.UPDATE_FLAGS:
            return { ...state, ...updateFlagValues(state, action.payload) };
        case ActionTypes.INITIALIZATION_COMPLETE:
            return { ...state, initialized: action.payload };
        default:
            return state;
    }
    function updateFlagValues(flagsState, changesPayload) {
        const { project, changes } = changesPayload;
        const currFlags = clone(flagsState.app.flags);
        for (const flag in changes) {
            if (Object.hasOwnProperty.call(changes, flag)) {
                currFlags[flag] = isFlagDeleted(changes[flag]) ? false : changes[flag].current;
            }
        }
        const changedFlagSet = { projectKey: project, flags: currFlags };
        return { app: changedFlagSet };
    }
    // tslint:disable-next-line:no-any
    function isFlagDeleted(flag) {
        return flag.current === undefined;
    }
}
//# sourceMappingURL=feature-flag.reducer.js.map